export default __webpack_public_path__ + "static/media/sihrd.287039a1.ico";